import React from 'react';
import { withTheme } from 'styled-components';
export var Bubble = withTheme(function (_ref) {
  var theme = _ref.theme,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'primary' : _ref$color;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "58",
    height: "56",
    viewBox: "0 0 58 56"
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M12.242 52.793c13.674 5.589 35.321 4.67 40.846-9.166C58.613 29.793 62.177 7.67 48.503 2.08 34.83-3.51 8.688 2.478 3.163 16.313c-5.523 13.835-4.594 30.89 9.08 36.479z",
    fill: theme.colors[color]
  })));
});